<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Принятие актов</h3>
      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по БИН/Номер акта"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin() || isManagerFC()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="hideAcceptedActs"
                     v-on:change="reloadList()"
                     v-model="page.filter.hideAcceptedActs"/>
              <label class="form-check-label" for="hideAcceptedActs">
                Скрывать утвержденные акты
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                :disabled="items.length === 0"
                @click="onClickGenerateReport()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН
        </div>
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          Название ВУЗа
        </div>
      </template>
      <template #head(numberAct)="data">
        <div class="sortable-container none"
             @click="onSortChanged('numberAct')"
             :class="{'ascending': page.sort.numberAct === 'ASC', 'descending': page.sort.numberAct === 'DESC'}">
          Номер акта
        </div>
      </template>
      <template #head(approveDate)="data">
        <div class="sortable-container none"
             @click="onSortChanged('approveDate')"
             :class="{'ascending': page.sort.approveDate === 'ASC', 'descending': page.sort.approveDate === 'DESC'}">
          Дата утверждения
        </div>
      </template>
      <template #head(statusNameRu)="data" v-if="isAdmin()">
        <div class="sortable-container none"
             @click="onSortChanged('statusNameRu')"
             :class="{'ascending': page.sort.statusNameRu === 'ASC', 'descending': page.sort.statusNameRu === 'DESC'}">
          Статус в АИИС ЭГЗ
        </div>
      </template>

      <template #cell(bin)="data">
        {{ data.item.report.university.bin }}
      </template>
      <template #cell(universityName)="data">
        {{ data.item.report.university.nameRu }}
      </template>
      <template #cell(numberAct)="data">
        {{ data.item.numberAct }}
      </template>
      <template #cell(approveDate)="data">
        {{ formatDate(data.item.approveDate) }}
      </template>
      <template #cell(statusNameRu)="data">
        {{ data.item.statusNameRu }}
      </template>
      <template #cell(actions)="data" v-if="isAdmin()">
        <button @click="onClickRefreshStatus(data.item)"
                v-if="!data.item.accepted"
                class="btn btn-sm btn-success">
          Запрос в АИИС ЭГЗ
        </button>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import {acceptActReconciliation, generateReport, getAllActReconciliations} from "@/services/actService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {saveAs} from "@/assets/FileSaver.min.js";
import delegationService from "@/services/delegationService";
import settingsService from "@/services/settingsService";
import universityService from "@/services/universityService";
import {VerificationStatusEnum} from "@/enum/VerificationStatus";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      page: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          bins: null,
          verificationStatus: VerificationStatusEnum.SUCCESSFUL,
          accepted: false,
          search: null,
          hideAcceptedActs: true
        },
        sort: {},
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      fields: [
        {key: 'bin', label: 'БИН', sortable: true},
        {key: 'universityName', label: 'Название ВУЗа', sortable: true},
        {key: 'numberAct', label: 'Номер акта', sortable: true},
        {key: 'approveDate', label: 'Дата утверждения', sortable: true},
        {key: 'statusNameRu', label: 'Статус в АИИС ЭГЗ', sortable: true},
        {key: 'actions', label: '', sortable: true}
      ],
      items: [],
      universities: []
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    async onClickRefreshStatus(item) {
      this.isLoading = true;
      const updatedItem = await acceptActReconciliation(item);
      Object.assign(item, updatedItem);
      this.isLoading = false;
    },
    async onClickGenerateReport() {
      this.isLoading = true;
      const response = await generateReport(TemplateTypeEnum.ACT_ACCEPTANCE_XLSX, this.page);
      const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    async reloadList() {
      this.isLoading = true;
      const response = await getAllActReconciliations(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },
    formatDate(dateTime) {
      if (!dateTime || dateTime.length === 0) {
        return null;
      }
      return dateTime.split(" ")[0];
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
  },
  mounted() {
    this.initUniversities();

    this.init();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}
</style>
